var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 71,
    viewBox: "0 0 75 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M42.9199 1.00613C38.0924 2.25224 34.0464 5.09824 31.58 9.46485C29.5511 13.0575 28.3649 17.222 25.467 20.2672C22.3799 23.511 19.8749 25.2095 15.5096 25.7124C-0.4086 27.5471 0.226032 53.8667 15.1177 64.3425C30.0093 74.8183 62.1442 73.4314 71.4191 43.0901C80.6939 12.7488 67.1096 4.49872 55.9403 1.22513C51.8754 0.0335123 47.1948 -0.0972927 42.9199 1.00613Z",
    fill: "#FFDCD4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.2148,
    y: 10.4766,
    width: 45.0158,
    height: 52.7692,
    rx: 2.95389,
    fill: "#3A6EEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3604,
    y: 12.625,
    width: 40.7286,
    height: 48.4615,
    rx: 2.95389,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 29.3203,
    width: 16.9851,
    height: 0.738462,
    rx: 0.369231,
    fill: "#081E54"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 33.0156,
    width: 16.9851,
    height: 0.738462,
    rx: 0.369231,
    fill: "#081E54"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 36.7031,
    width: 16.9851,
    height: 0.738462,
    rx: 0.369231,
    fill: "#081E54"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 40.3984,
    width: 16.9851,
    height: 0.738462,
    rx: 0.369231,
    fill: "#081E54"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.718,
    cy: 11.0661,
    rx: 10.718,
    ry: 10.7693,
    fill: "#E12D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4297 7.25L45.0031 15.8647",
    stroke: "white",
    strokeWidth: 1.03716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4324 15.8647L45.0059 7.25",
    stroke: "white",
    strokeWidth: 1.03716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75918 47.4883C3.42293 47.1653 3.4112 46.6276 3.73438 46.2879L8.76044 41.0048C9.08302 40.6657 9.61753 40.6526 9.95442 40.9762C10.2913 41.2998 10.3018 41.8363 9.97919 42.1754L4.95253 47.4591C4.62995 47.7982 4.09482 47.8119 3.75857 47.4889L3.75918 47.4883Z",
    fill: "#FF8165"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83068 47.3784L3.5909 42.3458C3.25465 42.0228 3.24293 41.4851 3.56611 41.1454C3.88929 40.8057 4.4232 40.7933 4.76008 41.1168L9.99986 46.1494C10.3361 46.4724 10.3478 47.0101 10.0253 47.3492C9.70269 47.6883 9.16757 47.702 8.83068 47.3784Z",
    fill: "#FF8165"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6871 33.1464C67.4629 32.9287 67.4558 32.5709 67.6712 32.3468L71.0251 28.8587C71.2405 28.6346 71.5967 28.6295 71.8209 28.8471C72.0451 29.0648 72.0523 29.4226 71.8368 29.6467L68.483 33.1348C68.2675 33.3589 67.9113 33.364 67.6871 33.1464Z",
    fill: "#FF8165"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1032 33.086L67.6123 29.6973C67.3881 29.4797 67.381 29.1218 67.5964 28.8977C67.8118 28.6737 68.168 28.6685 68.3922 28.8862L71.8831 32.2749C72.1073 32.4925 72.1144 32.8504 71.899 33.0744C71.6836 33.2985 71.3274 33.3036 71.1032 33.086Z",
    fill: "#FF8165"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejection);
export default __webpack_public_path__ + "static/media/Rejection.a8fc3fd0dcfd0c45f90b2769b5151a27.svg";
export { ForwardRef as ReactComponent };